<template>
  <div>
    <div class="row">
      <div class="col-12 mt-5">
        <h5>
          <span>Preguntas Frecuentes</span>
        </h5>
      </div>
    </div>
    <div class="row my-3" v-for="(question, i) in questions" :key="i">
      <div class="col-md-12">
        <Question :question="`${i + 1}. ${question.q}`" :answer="question.a" />
      </div>
    </div>
  </div>
</template>

<script>
import Question from "@/components/faq/Question";

export default {
  name: "Faq",
  data() {
    return {
      questions: [
        {
          q: "¿Qué tipos de textos hay en la plataforma?",
          a: `Existen “desafíos” o textos breves y libros completos que pueden ser usados como parte
              del plan de lectura complementaria. Todos estos cuentan con evaluaciones integradas que
              medirán y reforzarán de manera formativa la comprensión lectora de los estudiantes.`,
        },
        {
          q: "¿Qué hablidades de comprensión lectora trabaja BeeReaders?",
          a: `Trabajamos con las tres principales habilidades: localizar información, integrar e
              interpretar, y reflexionar y valorar. A partir de estas se desprenden un set de desempeños
              que apuntan a trabajar cada aspecto unitario de la comprensión lectora de un estudiante.
              Todas estas en su conjunto constituyen lo que denominamos la matriz de evaluación de
              BeeReaders`,
        },
        {
          q: "¿Cómo ganan puntos los estudiantes?",
          a: `Cada vez que contestan preguntas correctamente, BeeReaders los premia asignándoles
              puntaje el cual varía dependiendo de la dificultad del ejercicio y de lo avanzado que esté
              cada estudiante en su rutina de ejercitación.`,
        },
        {
          q: "¿Cómo puedoi revisar el catálago de libros que hay disponibles?",
          a: `Basta con hacer clic en el menú libros de su perfil. Ahí dentro encontrará un set de filtros
              que le ayudarán a encontrar lo que está buscando`,
        },
        {
          q:
            "¿Puedo sugerir libros para que se añadan al catálago en un futuro?",
          a: `¡Por supuesto! Trabajamos pensando en mejorar constantemente la oferta de nuestro contenido.
              Todas las sugerencias serán leídas y muy bienvenidas.`,
        },
        {
          q:
            "¿Cómo hago para agregar o eliminar un estudiante de mi lista de estudiantes?",
          a: `Para ello, necesitamos que nos indique los datos del estudiante y la razón de la
              modificación (ej: alumno fue retirado del colegio) a través de un correo electrónico
              enviado por el coordinador de BeeReaders en su colegio. De igual modo, puede
              escribirnos directamente a info@beereaders.com indicando su nombre completo, el
              nombre de su colegio y los detalles del estudiante que desea agregar o eliminar. Nuestro
              equipo se contactará con Ud. para validar la información.`,
        },
        {
          q: "¿Cómo asigno un libro para que mis estudiantes lean?",
          a: `En el Menú “Libros” puede revisar el catálago y escoger el libro que desea que sus
              estudiantes lean. Hecho eso, basta con hacer clic en “Asignar”, elegir fecha de inicio y
              término de la lectura y ya está.`,
        },
        {
          q: "¿Cómo puedo descargar los reportes?",
          a: `Basta con que vaya a su perfil en el sector superior derecho y seleccione la opción
              “Descargar Reportes”. Escoja el tipo de informe que desea exportar y ya está.`,
        },
        {
          q: "¿Qué hago si olvido mi clave?",
          a: `Basta con que se comunique con el coordinador de su colegio. Recuerde que,
              generalmente, su contraseña de acceso estará vinculada a su DNI o RUT, dependiendo de
              su país. De cualquier modo, podrá escribirnos a soporte@BeeReaders.com indicándonos
              sus datos completos y nuestro equipo técnico le ayudará.`,
        },
      ],
    };
  },
  components: {
    Question,
  },
};
</script>
